export const INPUT_TYPES = {
  TEXT: "TEXT",
  EMAIL: "EMAIL",
  NUMBER: "NUMBER",
  CURRENCY: "CURRENCY",
  PASSWORD: "PASSWORD",
  PHONE_NUMBER: "PHONE_NUMBER",
  MULTI_LINE_TEXT: "MULTI_LINE_TEXT",
} as const;
